import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {readall, fetch} from '../redux/modules/messages';
import {openTabForm} from '../redux/modules/tabs';
import {getWindowSize} from '../utils/utils';
import config from '../config';
import onClickOutside from 'react-onclickoutside'
import EventEmitter from '../EventEmitter';

@connect(null, {openTabForm})
class MessagesDropDownList extends React.Component {

	componentDidMount() {
		this.timeout = setTimeout(() => {
			this.props.onReadAll();
		}, 1000)
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	handleClick() {
		this.props.openTabForm('campaign', '...', {id: 30});
	}

	render() {
		return <div className="dropdown-menu dropdown-content width-350">
				<ul className="media-list dropdown-content-body">
					{this.props.messages.map((item) => {
						return (
							<li className="media">
								<div className="media-body">
									<a onClick={(e) => {e.preventDefault()}} href="#" className="media-heading">
										<span className={'text-semibold ' + (item.readed ? 'text-mutedd' : '')}>{item.subject}</span>
										<span className="media-annotation pull-right">{item.created}</span>
									</a>
									<span className={(item.readed ? 'text-mutedd' : '')}>{item.text}</span>
								</div>
							</li>
						)
					})}
				</ul>
			</div>
	}
}


@connect(state => {
	return {
		user: state.auth.identity,
		messages: state.messages,
	}
},
{openTabForm, readall, fetch}, null, {withRef:true})
@onClickOutside
export default class MessagesDropDown extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.state = {
			messagesOpen: false
		}
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refresh();
		};
		EventEmitter.on('imessages.change.' + this.props.user.id , this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('imessages.change.' + this.props.user.id, this.changeListener);
	}

	handleClickMessagesButton(e) {
		if (e) {
			e.preventDefault();
		}
		this.setState({messagesOpen:!this.state.messagesOpen});
	}

	handleReadAll() {
		this.props.readall();
	}

	refresh() {
		this.props.fetch();
	}

	handleClickOutside() {
		this.setState({messagesOpen:false});
	}

	render() {
		if (this.props.messages.length == 0) {
			return <li className="hidden"></li>;
		}

		return <li className={classNames('dropdown', {'open':this.state.messagesOpen})}>
			<a href="#" onClick={(e) => this.handleClickMessagesButton(e)} className="dropdown-toggle">
				<i className="icon-envelop2" style={{color: this.props.messages.filter((item)=>!item.readed).length == 0 ? '#CCC' : ''}}></i>
				<span className="visible-xs-inline-block position-right">Zprávy</span>
				{this.props.messages.filter((item)=>!item.readed).length > 0 && <span className="badge bg-primary-400">{this.props.messages.filter((item)=>!item.readed).length}</span>}
			</a>
			{this.state.messagesOpen && <MessagesDropDownList messages={this.props.messages} onHide={() => this.handleClickMessagesButton()} onReadAll={() => this.handleReadAll()} />}
		</li>
	}
}


// WEBPACK FOOTER //
// ./src/components/MessagesDropDown.js